import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function signOut(): Promise<boolean> {
    const signOutPromise = async () => {
        const { error } = await supabase.auth.signOut();

        if (error) {
            throw new Error(error.message);
        }

        return true;
    };

    try {
        const result = await toast.promise(
            signOutPromise(),
            {
                pending: "Signing out...",
                success: "Signed out successfully!",
                error: "Failed to sign out"
            }
        );
        return result;
    } catch (err) {
        console.log("Sign out error:", err);
        return false;
    }
}
